import { render, staticRenderFns } from "./RelatedInfo.vue?vue&type=template&id=db2bfe36&scoped=true&"
import script from "./RelatedInfo.vue?vue&type=script&lang=js&"
export * from "./RelatedInfo.vue?vue&type=script&lang=js&"
import style0 from "./RelatedInfo.vue?vue&type=style&index=0&id=db2bfe36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2bfe36",
  null
  
)

export default component.exports